"use strict";

var _interopRequireDefault = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _pincode = require("@/api/pincode");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _utils = require("@/utils");
var _countries = require("@/api/locations/countries");
var _states = require("@/api/locations/states");
var _cities = require("@/api/locations/cities");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.countryList = [];
    this.stateList = [];
    this.cityList = [];
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, _pincode.defaultPincodeData);
    this.loading = false;
    this.rules = {
      pincodeName: [{
        required: true,
        message: 'Please enter Pincode',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      pincode: [{
        required: true,
        message: 'Please enter Pincode',
        trigger: 'blur'
      }, {
        min: 6,
        max: 6,
        message: 'Length should be 6',
        trigger: 'blur'
      }],
      homeDeliveryCharges: [{
        required: true,
        message: 'Please enter Charges',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return _app.AppModule.language;
  }
  activated() {
    // this.getCountryList()
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, _pincode.defaultPincodeData);
      this.formData.cityId = parseInt(this.$route.params && this.$route.params.cityId);
      this.fetchCity(this.formData.cityId);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _pincode.getPincodeById)(id);
      this.formData = data;
      // Just for test
      const title = this.formData.pincodeName;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchCity(id) {
    try {
      const cityData = await (0, _cities.getCityById)(id);
      this.formData.stateId = cityData.stateId;
      this.formData.countryId = cityData.countryId;
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async checkIfPincodeExists() {
    if (!this.formData.pincode) {
      return false;
    }
    const query = {
      pincode: this.formData.pincode,
      filter: {
        pincode: '$eq'
      }
    };
    const existing = await (0, _pincode.getPincodes)((0, _utils.getQuery)(query));
    const matches = (existing.data || []).filter(p => p.id !== this.formData.id);
    return matches.length > 0;
  }
  async getCountryList() {
    try {
      this.getStateList();
      this.countryList = await (0, _countries.getCountries)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getStateList() {
    try {
      this.getCityList();
      this.stateList = await (0, _states.getStates)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getCityList() {
    try {
      this.cityList = await (0, _cities.getCities)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      Promise.reject(err);
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      const pincodeExists = await this.checkIfPincodeExists();
      if (pincodeExists) {
        this.loading = false;
        this.$notify.error({
          title: 'Error',
          message: 'This pincode already exists'
        });
        return;
      }
      if (this.isEdit) {
        this.formData.state.id = this.formData.stateId;
        this.formData.city.id = this.formData.cityId;
        await (0, _pincode.updatePincode)(this.formData.id, this.formData);
      } else {
        delete this.formData.country;
        delete this.formData.state;
        delete this.formData.city;
        await (0, _pincode.createPincode)(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Pincode saved successfully',
        type: 'success',
        duration: 2000
      });
      _router.default.push({
        path: '/pincode/list/' + this.formData.cityId,
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'PincodeDetail',
  components: {}
})], default_1);
var _default = exports.default = default_1;